import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const Shop: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            Shop
        </div>
    )
}

export const ShopSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        Shop
    </div>
}

export default Shop